import { NavigateOptions, useNavigate } from 'react-router-dom';

import { useUserStore } from '@/stores/user.store';

// The WO email deep-link; app-bootstrap skips it so the resolver can reach the specific WO, not the GBMW root.
export function isWorkOrderDeepLinkPath(pathname: string): boolean {
  return /^\/workspaces\/[^/]+\/work-orders\/[^/]+\/?$/.test(pathname);
}

export function getWorkspaceRoute(path: string) {
  const { org } = useUserStore.getState();
  if (!org?.workspaceId) return path;
  return `/workspaces/${org.workspaceId}${path}`;
}

export function useWorkspaceNavigate() {
  const { org } = useUserStore();
  const navigate = useNavigate();

  return (to: string | number, options?: NavigateOptions) => {
    if (typeof to === 'number') {
      navigate(to);
    } else if (typeof to === 'string' && org?.workspaceId) {
      navigate(`/workspaces/${org.workspaceId}${to}`, options);
    } else {
      navigate('/', options);
    }
  };
}

export function useEditFormNavigate() {
  const navigate = useWorkspaceNavigate();
  return (formId: string) => {
    navigate(`/forms/${formId}`);
  };
}
